import { McLeodClassicIntegration } from "@mcleod/core";
import { AutogenLayoutStatusResolution } from "./autogen/AutogenLayoutStatusResolution";

export class StatusResolution extends AutogenLayoutStatusResolution {
    override onLoad(): void {
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.edi.PanelEdiStatusError", "<ext> search ready_to_send !='V'");
    }
}
